module.exports = __webpack_public_path__ + "static/react-555c34468658bd8099bba65e67319b7c.png";